import { Route, Routes, useLocation } from "react-router-dom"
import Home from "./pages/Home"
import { useEffect, useState } from "react";
import CustomCursor from "./components/CustomCursor";
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import UpBtn from "./components/UpBtn";
import SearchBar from "./components/SearchBar";
import MobileMenu from "./components/MobileMenu";
import Footer from "./components/Footer";
import Experiments from "./pages/Experiments";
import USAExperimentDetails from "./pages/USAExperimentDetails";
import GermanyExperimentDetails from "./pages/GermanyExperimentDetails";
import KoreaExperimentDetails from "./pages/KoreaExperimentDetails";
import RussiaExperimentDetails from "./pages/RussiaExperimentDetails";
import Methods from "./pages/Methods";
import Method3I from "./methods/Method3I";
import MethodCLIL from "./methods/MethodCLIL";
import MethodGRASPS from "./methods/MethodGRASPS";
import MethodQoshDaraxt from "./methods/MethodQoshDaraxt";
import MethodSMART from "./methods/MethodSMART";
import MethodSQ3R from "./methods/MethodSQ3R";
import MethodWHERETO from "./methods/MethodWHERETO";
import ErrorPage from "./pages/ErrorPage";
import MethodRecommender from "./pages/MethodRecommender";
import MethodCompare from "./pages/MethodCompare";
import LessonPlanner from "./pages/LessonPlanner";
import Quiz from "./pages/Quiz";
import ExperimentsMap from "./pages/ExperimentsMap";
import Students from "./pages/Students";
import Diagnostics from "./pages/Diagnostics";
import Cases from "./pages/Cases";
import Reflection from "./pages/Reflection";
import Challenge from "./pages/Challenge";
import StudentModules from "./pages/StudentModules";
import StudentModule from "./pages/StudentModule";

function App() {
  const location = useLocation();
  const [searchBarShow, setSearchBarShow] = useState(false);
  const [mobileMenuShow, setMobileMenuShow] = useState(false);
  const [mobileMenuList, setMobileMenuList] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handlePageLoad = () => {
      setLoading(false);
    };

    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
      return () => window.removeEventListener("load", handlePageLoad);
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname])
  return (
    <div className="page-wrapper">
      {loading
        ?
        <Preloader />
        :
        <>
          <CustomCursor />
          <Navbar setSearchBarShow={setSearchBarShow} setMobileMenuShow={setMobileMenuShow} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/experiments" element={<Experiments />} />
            <Route path="/methods" element={<Methods />} />
            <Route path="/method/3I" element={<Method3I />} />
            <Route path="/method/CLIL" element={<MethodCLIL />} />
            <Route path="/method/GRASPS" element={<MethodGRASPS />} />
            <Route path="/method/qosh_daraxt" element={<MethodQoshDaraxt />} />
            <Route path="/method/SMART" element={<MethodSMART />} />
            <Route path="/method/SQ3R" element={<MethodSQ3R />} />
            <Route path="/method/WHERETO" element={<MethodWHERETO />} />
            <Route path="/experiment/usa" element={<USAExperimentDetails />} />
            <Route path="/experiment/germany" element={<GermanyExperimentDetails />} />
            <Route path="/experiment/korea" element={<KoreaExperimentDetails />} />
            <Route path="/experiment/russia" element={<RussiaExperimentDetails />} />
            <Route path="/recommender" element={<MethodRecommender />} />
            <Route path="/compare" element={<MethodCompare />} />
            <Route path="/planner" element={<LessonPlanner />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/map" element={<ExperimentsMap />} />
            <Route path="/students" element={<Students />} />
            <Route path="/diagnostics" element={<Diagnostics />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/reflection" element={<Reflection />} />
            <Route path="/challenge" element={<Challenge />} />
            <Route path="/student-modules" element={<StudentModules />} />
            <Route path="/student-modules/:id" element={<StudentModule />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
          <MobileMenu
            setMobileMenuShow={setMobileMenuShow}
            mobileMenuShow={mobileMenuShow}
            setMobileMenuList={setMobileMenuList}
            mobileMenuList={mobileMenuList}
          />
          <SearchBar setSearchBarShow={setSearchBarShow} searchBarShow={searchBarShow} />
          <UpBtn />
          <Footer />
        </>
      }
    </div>
  )
}

export default App